module.exports = __webpack_public_path__ + "static/media/img-video.9de19313.png";